<div class="modulo contato-suporte-modulo">
      <div class="modulo-content">
            <nav>
                  <ul>
                        <li *ngFor="let d of data.destinos">
                              <a routerLink="/destinos/{{d.apelido}}" alt="{{d.nome}}">
                                    {{d.nome}}
                              </a>
                        </li>      
                  </ul>
            </nav>      
      </div>      
</div>      